// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XOhA396e7gJt9o7P9Rhr{flex-direction:column;gap:24px;margin-top:32px;padding-left:24px;padding-right:24px;display:flex}.Sb9w9WJkFUW2yzX2oEia{flex-direction:column;gap:4px;display:flex}.Sb9w9WJkFUW2yzX2oEia .RyIajzH5cuQJJUO_Uw_o{padding-top:8px;padding-bottom:8px}.uo4FbIuV7qM0JFtzzwo9{align-items:center;gap:8px;display:flex}.D0FVjsNnUsIrxJt0ikGG{grid-template-columns:130px auto;align-items:flex-start;display:grid}.D0FVjsNnUsIrxJt0ikGG .Wu2d3y3HMoUClpfiTLqB{min-height:32px;color:var(--content-primary-tertiary);align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XOhA396e7gJt9o7P9Rhr`,
	"block": `Sb9w9WJkFUW2yzX2oEia`,
	"title": `RyIajzH5cuQJJUO_Uw_o`,
	"wrapPlaceholder": `uo4FbIuV7qM0JFtzzwo9`,
	"grid": `D0FVjsNnUsIrxJt0ikGG`,
	"label": `Wu2d3y3HMoUClpfiTLqB`
};
export default ___CSS_LOADER_EXPORT___;
